import React, { useState, useEffect } from 'react';
import { getStorage } from 'helpers/sessionContext';

export const TolgeeStaffToolbar: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [apiKey, setApiKey] = useState('');
    const [isSaved, setIsSaved] = useState(false);
    const [showInput, setShowInput] = useState(false);

    useEffect(() => {
        const isStaff = getStorage().getItem('tg_staff_mode') === 'true';
        const savedKey = getStorage().getItem('tg_api_key');
        setIsVisible(isStaff);
        if (savedKey) {
            setApiKey(savedKey);
            setIsSaved(true);
        } else {
            setShowInput(true);
        }
    }, []);

    const handleSave = () => {
        if (apiKey.trim()) {
            getStorage().setItem('tg_api_key', apiKey.trim());
            setIsSaved(true);
            setShowInput(false);
            window.location.reload();
        }
    };

    const handleExit = () => {
        getStorage().removeItem('tg_staff_mode');
        getStorage().removeItem('tg_api_key');
        window.location.href = window.location.pathname;
    };

    if (!isVisible) return null;

    return (
        <div style={{
            position: 'fixed',
            bottom: '30px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 100000,
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            padding: '8px 24px',
            backgroundColor: '#1e293b',
            borderRadius: '12px',
            border: '1px solid #334155',
            boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
            color: 'white',
            fontFamily: 'sans-serif',
            transition: 'all 0.3s ease',
        }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div style={{
                    width: '10px',
                    height: '10px',
                    borderRadius: '50%',
                    backgroundColor: isSaved ? '#22c55e' : '#eab308',
                    animation: isSaved ? 'none' : 'pulse 2s infinite'
                }} />
                <span style={{ fontWeight: 600, fontSize: '14px' }}>Cincel Editor Mode</span>
            </div>

            {(showInput || !isSaved) ? (
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <input
                        type="password"
                        placeholder="Pega tu API Key de Tolgee..."
                        value={apiKey}
                        onChange={(e) => setApiKey(e.target.value)}
                        style={{
                            backgroundColor: '#0f172a',
                            border: '1px solid #475569',
                            borderRadius: '6px',
                            padding: '6px 12px',
                            color: 'white',
                            fontSize: '13px',
                            width: '240px',
                            outline: 'none',
                        }}
                    />
                    <button
                        onClick={handleSave}
                        style={{
                            backgroundColor: '#3b82f6',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            padding: '6px 16px',
                            fontSize: '13px',
                            fontWeight: 500,
                            cursor: 'pointer',
                        }}
                    >
                        Conectar
                    </button>
                </div>
            ) : (
                <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                    <span style={{ fontSize: '13px', color: '#94a3b8' }}>Conectado (Alt+Click para editar)</span>
                    <button
                        onClick={() => setShowInput(true)}
                        style={{
                            background: 'none',
                            border: 'none',
                            color: '#3b82f6',
                            cursor: 'pointer',
                            fontSize: '12px',
                            textDecoration: 'underline'
                        }}
                    >
                        Cambiar Key
                    </button>
                </div>
            )}

            <div style={{ width: '1px', height: '24px', backgroundColor: '#334155' }} />

            <button
                onClick={handleExit}
                style={{
                    backgroundColor: 'transparent',
                    border: '1px solid #ef4444',
                    color: '#ef4444',
                    borderRadius: '6px',
                    padding: '4px 12px',
                    fontSize: '12px',
                    fontWeight: 600,
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                }}
                onMouseOver={(e) => (e.currentTarget.style.backgroundColor = 'rgba(239, 68, 68, 0.1)')}
                onMouseOut={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
            >
                Salir
            </button>

            <style>{`
        @keyframes pulse {
          0% { opacity: 1; }
          50% { opacity: 0.5; }
          100% { opacity: 1; }
        }
      `}</style>
        </div>
    );
};
